import controller from './environment';
import template from './environment.html';
import './environment.scss';

const component = {
	bindings: {},
	template,
	controller
};

export default component;



// WEBPACK FOOTER //
// ./src/modules/topbar/components/environment/index.js